import DataCloudIcon from './DataCloudIcon'

export default DataCloudIcon
